import React from 'react';
import { Box, Typography, Card, CardContent, Grid2 as Grid, Link } from '@mui/material';
import { LinkedIn } from '@mui/icons-material';
import { teamMembers, MeetOurExpertTeamTitle } from './constants';
import './ourExperts.css';

const TeamSection = () => {
  return (
    <Box className="container-team">
      <Box className="team-section">
        {/* Header Section */}
        <Typography variant="h1" className="team-title" gutterBottom>
          {MeetOurExpertTeamTitle}
        </Typography>

        {/* Team Members Section */}
        <Grid container spacing={2} className="team-grid">
          {teamMembers.map((member, index) => (
            <Grid xs={10} sm={6} md={2} key={index}>
              <Card id="team-card">
                {/* Image Section */}
                <Box component="img" src={member.image} alt={member.name} id="team-image" />

                {/* Text Overlay */}
                <CardContent id="team-content">
                  <Typography id="team-name" gutterBottom>
                    {member.name}
                    <Link id="team-link" target="_blank" href={`${member.link}`}>
                      <LinkedIn fontSize="medium" />
                    </Link>
                  </Typography>
                  <Typography id="team-role">{member.position}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default TeamSection;
